import axios from 'axios';

export const copyToClipboard = async (text: string) => {
  try {
    await navigator.clipboard.writeText(text);
  } catch (err) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.cssText = 'position:fixed;opacity:0;pointer-events:none;';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);
  }
};

export const downloadFileByUrl = (url: string, filename: string) => {
  const anchor = document.createElement('a');
  anchor.href = `${url}/download`;
  anchor.download = filename || 'download';
  anchor.target = '_blank';
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
};

export const downloadFile = async (url: string, fileName: string) => {
  const res = await axios({
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    responseType: 'blob',
    url,
  });
  const objectURL = window.URL.createObjectURL(new Blob([res.data]));
  const link = document.createElement('a');
  link.href = objectURL;
  link.setAttribute('download', 'flyer.pdf');
  document.body.appendChild(link);
  link.click();
};
